<template>
  <div>
    <template v-if="editSoaIndex === index && !soa.isAutoSoa">
      <span>{{convertNumber(soa.outgoing || 0)}}</span>
    </template>
    <template v-else>
      <span>{{convertNumber(soa.outgoing || 0)}}</span>
    </template>
  </div>
</template>

<script>
import convertNumber from '@/mixin/convertNumber'
export default {
  name: 'OutgoingColumn',
  props: ['soa', 'editSoaIndex', 'index'],
  mixins: [convertNumber]
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/OutgoingColumn.vue